import { render, staticRenderFns } from "./ShowIcons.vue?vue&type=template&id=06e53c63&scoped=true&"
import script from "./ShowIcons.vue?vue&type=script&lang=js&"
export * from "./ShowIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e53c63",
  null
  
)

export default component.exports